export enum StatusType {
  AccountStatus = 1,
  AccountContactStatus,
  SenderIDStatus,
  OPAAuthorisationStatus,
}